import { Link } from "react-router-dom"
import errorImg from '../assets/images/error/error.jpg'

const NotFound = () => {

    return(
        <div
        className="flex flex-col items-center gap-2 bg-purple justify-center h-screen overflow-hidden font-kalameh">
            <div className="bg-white overflow-hidden p-5 shadow-lg w-5/6 h-5/6 flex flex-col-reverse lg:flex-row justify-between lg:px-20 items-center rounded-[35px]">
               
            <div
            className="lg:w-1/2 h-full flex flex-col justify-center items-center gap-5"
            >
                    <p
            className="text-[18px] lg:text-[22px]"
            >
                متاسفانه صفحه موردنظر پیدا نشد.
            </p>
            <Link
            to={'/'}
            className="bg-purple hover:bg-opacity-30 hover:text-purple transition-all py-2 px-8 rounded-full lg:text-[18px] text-white"
            >
                صفحه اصلی
            </Link>
            </div>
             <div
                className="sm:w-2/3 lg:w-1/2"
                >
                    <img src={errorImg}
                    className=" object-contain"
                    alt="" />
                </div>
            </div>
        </div>
    )
}
export default NotFound